import type { ItemFieldEntry } from '@cheqroom/api';

import type { InfoField } from '../Fields.types';

/**
 * Sorts resolved fields into the order of `fieldDefs`. System and custom fields are resolved
 * separately, so concatenating them puts every custom field after every system field. That drops
 * the order the user saved when a custom field sits above a system one. The sort is stable, and a
 * field with no def keeps its place at the end.
 */
export const orderFieldsByDefs = (fields: InfoField[], fieldDefs: ItemFieldEntry[] = []): InfoField[] => {
	const position = new Map(fieldDefs.map((def, index) => [def.id, index]));
	const rank = (field: InfoField) => position.get(field.id) ?? Number.MAX_SAFE_INTEGER;
	return [...fields].sort((a, b) => rank(a) - rank(b));
};
